var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.94263 10.8107L6.93179 12.8215C6.69381 13.0595 6.308 13.0595 6.07001 12.8215L4.05917 10.8107C3.67529 10.4268 3.94717 9.7704 4.49008 9.77043H5.78911L5.78909 7.21094H3.22961V8.50997C3.22961 9.05287 2.57323 9.32475 2.18933 8.94087L0.17849 6.93004C-0.0594966 6.69205 -0.0594966 6.30622 0.17849 6.06826L2.18933 4.05743C2.57321 3.67355 3.22961 3.94543 3.22961 4.48833V5.78906H5.78909V3.2296H4.48832C3.94542 3.2296 3.67354 2.57322 4.05742 2.18932L6.06826 0.178489C6.30624 -0.0594964 6.69206 -0.0594964 6.93004 0.178489L8.94088 2.18932C9.32476 2.5732 9.05288 3.2296 8.50998 3.2296H7.21094V5.78906H9.77042V4.49003C9.77042 3.94713 10.4268 3.67525 10.8107 4.05913L12.8215 6.06996C13.0595 6.30795 13.0595 6.69378 12.8215 6.93174L10.8107 8.94257C10.4268 9.32645 9.77039 9.05457 9.77042 8.51167V7.21094H7.21096V9.7704H8.51173C9.05463 9.7704 9.32651 10.4268 8.94263 10.8107Z",
    fill: "#434E52"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMark);
export default __webpack_public_path__ + "static/media/mark.0bf9398991f53081b0fc689983fd1ba2.svg";
export { ForwardRef as ReactComponent };